import type { JSX } from "react";
import type { Permission } from "@mainsail/schema";
import type { ChildrenProp } from "@charterindex/armoury-www";
import { useObservable } from "ecce-react";
import { useAuth } from "../../services/services-context";


export type WithPermissionProps = ChildrenProp & {
	permission: Permission | "ANY_PERMISSION";
};
export const WithPermission = ({ permission, children }: WithPermissionProps): JSX.Element | null => {
	const auth = useAuth();
	useObservable(auth, "activeUser");

	if(permission !== "ANY_PERMISSION" && !auth.hasPermission(permission)) {
		return null;
	}

	return children as JSX.Element;
};